import { FormValues } from "./types";

export const INITIAL_VALUES: FormValues = {
  entityType: "",
  amlEntityType: "",
  entityName: "",
  streetLine1: "",
  streetLine2: "",
  country: "",
  city: "",
  stateOrProvince: "",
  zipCode: "",
  dateOfFormation: undefined,
  taxId: "",
  ownershipPercentage: 0,
  isOwner: false,
  isController: false,
  registrationNumber: "",
  natureOfBusiness: "",
  principalPlaceOfBusiness: "",
};

// Key mappings of extracted data from query and form values
export const FIELD_MAPPING: Partial<Record<keyof FormValues, string>> = {
  entityName: "legal_name",
  streetLine1: "street",
  streetLine2: "street2",
  city: "city",
  stateOrProvince: "state",
  country: "country",
  zipCode: "postal_code",
  dateOfFormation: "date_of_organization",
};
